module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reach-calculator",
    class: _vm.$style.root
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('pos.target.potential-users')) + ": "), (_vm.loading) ? _c('icon', {
    attrs: {
      "name": "refresh",
      "spin": "spin"
    }
  }) : _c('span', {
    attrs: {
      "data-potential-reach": _vm.reach
    }
  }, [_vm._v(_vm._s(_vm.$t('fn.number', {
    value: _vm.reach
  })))])], 1), _vm._t("reach-warning")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e57d710"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reach-calculator/ReachCalculator.vue
// module id = 915
// module chunks = 1